import React from 'react';
import Icon from '../../ui/icon/icon';
import RateCard from '../rateCard/rateCard';
import { classnames } from '../../../../utils/classnames';
import './rateSubGroupCard.css';

export default function RateSubGroupCard({group, mode, event, selectedRates, setSelectedRates, max_ticket, expand_rate_groups, currency, disable_plus, disable_minus}) {
    const [showMore, setShowMore] = React.useState(expand_rate_groups === '0' ? false : true);
    const toggleShowMore = React.useCallback(() => setShowMore(showMore => !showMore), []);

    return (
        <>
            <h3>
                <button type='button' id={`group_${group.id}`} aria-expanded={String(showMore)} aria-controls={`group_${group.id}_section`} className='neo-rate-sub-group-card__trigger' onClick={toggleShowMore}>
                    <div className='neo-rate-sub-group-card__trigger-content'>
                        <div className='neo-rate-sub-group-left'>
                            <div className='neo-rate-sub-group-icon'>
                                <Icon name='linkfolder' className={'neo-rate-sub-group-icon-left'}/>
                            </div>
                            <p className='neo-rate-sub-group-title'>{group.name}</p>
                        </div>
                        <div className='neo-rate-group-right'>
                            <div className='neo-rate-sub-group-icon-container'>
                                <Icon name='arrow' size='small' className={`neo-rate-sub-group-icon ${showMore ? 'neo-rate-sub-group-icon-down' : 'neo-rate-sub-group-icon-up'}`} />
                            </div>
                        </div>
                    </div>
                </button>
            </h3>
            <div 
                role="region" 
                id={`group_${group.id}_section`} 
                aria-labelledby={`group_${group.id}`}
                className={classnames('neo-attendee-sub-rate-group-children', {'display-block': showMore})}
            >
                {group.rates.map(rate => (
                    <RateCard key={rate.id} mode={mode} rate={rate} event={event} selectedRates={selectedRates} setSelectedRates={setSelectedRates} max_ticket={max_ticket} currency={currency} disable_plus={disable_plus} disable_minus={disable_minus}/>
                ))}
                {group.children.map(gr => (
                    <RateSubGroupCard key={gr.id} mode={mode} className='neo-subgroup' group={gr} event={event} selectedRates={selectedRates} setSelectedRates={setSelectedRates} max_ticket={max_ticket} expand_rate_groups={expand_rate_groups} currency={currency} disable_plus={disable_plus} disable_minus={disable_minus}/>
                ))}
            </div>
        </>
    )
}
